<template>
<div class="chapter">
<div class="inner_page">
<p class="bk-title"><a id="piii"></a><span class="small">THE</span> <br/>Sorcerer’s <br/>Apprentice</p>
<p class="bk-subtitle"><span class="fsc">AN ANTHOLOGY</span> <i>of</i> <span class="fsc">MAGICAL TALES</span></p>
<p class="bk-edition"><span class="fsc">EDITED BY</span></p>
<p class="bk-author">Jack Zipes</p>
<p class="bk-author1"><span class="fsc">ILLUSTRATED BY NATALIE FRANK</span></p>
<p class="BK-pub"><span class="fsc">PRINCETON UNIVERSITY PRESS</span></p>
<p class="BK-pub1"><i>Princeton &amp; Oxford</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title_page.vue?4e2a8711